import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IItemDropdown } from 'src/app/core/interfaces/dropdown.models';
import { ProvinciaDialogService } from './provincia-dialog.service';
import {Provincia, ProvinciaRequestPaginated} from "./provincia-dialog.model";
import { MessageConstants } from 'src/app/core/constants/message';
import { SecureStorageService } from 'src/app/core/validators/secure-storage.service';

@Component({
  standalone: false,
  selector: 'app-provincia-dialog',
  templateUrl: './provincia-dialog.component.html',
  styleUrls: ['./provincia-dialog.component.css']
})
export class ProvinciaDialogComponent implements OnInit {
  isFirstLoad: boolean = true;
  totalRows: number = 0;
  lsProvincia: Provincia[] = [];
  codigosMessage: any;
  mensajesMessage: any;
  loading: boolean = false;
  readonly: boolean = false;

  constructor(private ProvinciaDialogService: ProvinciaDialogService
    , public ref: DynamicDialogRef
    , public config: DynamicDialogConfig
    , private secureStorageService: SecureStorageService
  ){
      this.readonly = config.data.readonly
  }

  ngOnInit(): void {
    this.loading = true;
    const companyId = this.secureStorageService.getData("CompanyId");
    let ProvinciaReq: ProvinciaRequestPaginated = {
      Nombre:'',
      Codigo:'',
      CompanyId: companyId
    };
    this.getProvinciaData(ProvinciaReq);
  }


  getProvinciaData(request: ProvinciaRequestPaginated){

    [this.codigosMessage, this.mensajesMessage] = MessageConstants;
    this.ProvinciaDialogService.getPaginated(request)
      .subscribe(
        {
          next: (data) => {
            let dataTmp = data;
            if(dataTmp) {
              this.lsProvincia = dataTmp;
            }
          },
          error: (error) => {
            if(error){
              console.log(error);
            }
          },
          complete: () => {
            this.loading = false;
          }
        }
      );
  }

  onRowDblClick(event: any, dataSelected: any){

    if(this.readonly)return;
    
    if(dataSelected){
      let _description = ((dataSelected.Nombre) ? dataSelected.Nombre : "" ) ;
      let itemDropdown: IItemDropdown = {
        code: dataSelected.Id,
        description: _description,
        dataSerialize: JSON.stringify(dataSelected)
      }
      this.ref.close(itemDropdown);
    }

  }

}
